import React, { useEffect, useState } from "react";
import axios from "axios";
import { get } from "lodash";
import {
  SdfAlert,
  SdfBusyIndicator,
  SdfButton,
  SdfFocusPane,
  SdfIcon,
  SdfInput,
} from '@synerg/react-components'
import { ILProjectListTable } from "./ilProjectListTable";

const ImportLegacyProject = (props = {}) => {
  const { setShowSlideInModal, searchedOOID } = props;

  // USE STATE
  const [loading, setLoading] = useState(false);
  const [isError, setError] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const [infoMessage, setInfoMessage] = useState(null);

  // SEARCH INPUT
  const [searchInputState, setSearchInputState] = useState({
    value: searchedOOID || "", //G3X0VY1FWBBXWJV5
    error: false,
    errorMessage: "",
  });
  const [projectList, setProjectList] = useState([]);

  // Effects
  useEffect(() => {
    if (searchedOOID) {
      setSearchInputState({ ...searchInputState, value: searchedOOID });
      searchLegacyProjects();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchedOOID]);

  // FORM INPUT EVENTS
  const ooidChangeHandler = (value) => {
    setSearchInputState({
      error: false,
      errorMessage: "",
      value,
    });
  };

  // UTILS
  const startAPICall = () => {
    setLoading(true);
    setError(false);
    setShowToast(false);
    setInfoMessage(null);
  };

  // API CALLS
  const searchLegacyProjects = async () => {
    const { value } = searchInputState;
    if (value) {
      startAPICall();
      try {
        const {
          data: { partnerType, legacyProjects },
        } = await axios(
          `${import.meta.env.VITE_ROOT_PATH}/api/partner/${value}/legacy/projects`
        );
        setProjectList(
          legacyProjects.map((d) => ({ ...d, partnerType, ooid: value }))
        );
        console.log(
          legacyProjects.map((d) => ({ ...d, partnerType, ooid: value }))
        );
      } catch (e) {
        setError(true);
        setShowToast(true);
        setInfoMessage(
          get(
            e,
            "response.data.message",
            "Something went wrong when trying to get Project List. Please try again."
          )
        );
      } finally {
        setLoading(false);
      }
    } else {
      setSearchInputState({
        ...searchInputState,
        error: true,
        errorMessage: "Enter OOID to continue.",
      });
    }
  };

  return (
    <React.Fragment>
      <SdfFocusPane
        visible={true}
        paneType="anchored"
        size="xl"
        hideAcceptButton={true}
        hideDismissButton={true}
        onSdfDismiss={() => {
          setShowSlideInModal(false);
        }}
        closeable={true}
        dismissOnClickOutside={true}
      >
        <div className="w-full">
          <div className="pl-6 pr-4">
            {loading ? (
              <SdfBusyIndicator
                style={{ color: "#1a8099" }}
                size="xl"
                fullScreen={true}
                overlay={true}
              />
            ) : null}

            <SdfAlert
              className="fixed min-w-1/3"
              style={{ top: "6rem", right: "calc(100% - 66%)", zIndex: "9999" }}
              hidden={!showToast}
              autoClose={true}
              autoCloseAfter={3000}
              closeable={true}
              useAnimation={true}
              status={isError ? "error" : "success"}
            >
              {infoMessage}
            </SdfAlert>

            <div className="text-heading-05 font-bold">
              Import legacy projects
            </div>
            <div className="inline-flex items-start gap-5">
              <div className="">
                <SdfInput
                  className="min-w-xs m-0 p-0"
                  placeholder="Search by OOID"
                  value={searchInputState.value}
                  state={searchInputState.error ? "error" : "normal"}
                  onSdfInput={(event) => ooidChangeHandler(event.detail)}
                >
                  <SdfIcon slot={"after"} icon={"action-search"} />
                  {searchInputState.error && (
                    <SdfAlert
                      slot="alert"
                      size="sm"
                      status="error"
                      type="inline"
                    >
                      {searchInputState.errorMessage}
                    </SdfAlert>
                  )}
                </SdfInput>
              </div>
              <div className="mt-6">
                <SdfButton emphasis="primary" onClick={searchLegacyProjects}>
                  Find projects
                </SdfButton>
              </div>
            </div>
            <div className="w-full mt-8">
              <ILProjectListTable
                projectList={projectList}
                setLoading={setLoading}
                setShowToast={setShowToast}
                setError={setError}
                setInfoMessage={setInfoMessage}
                reloadProjectList={searchLegacyProjects}
              />
            </div>
          </div>
        </div>
      </SdfFocusPane>
    </React.Fragment>
  );
};
export default ImportLegacyProject;
